import { InputNumber } from "antd";
import styled from "styled-components";
import { useAdvancedFormContext } from "../advanced-form";
import { InputStyled } from "./form-item-string";

const InputNumberStyled = styled(InputNumber)`
  width: 100%;
`

const formatter = (value) => {
  if(!value) return value;
  const [start, end] = `${value}`.split('.') || [];
  const v = `${start}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return `${end ? `${v},${end}` : `${v}`}`;
};

const parser = (value) => value?.replace('.', '').replace(',', '.') as unknown as number

function FormItemNumber({ readOnly, disabled, min, max, addonAfter, value, onChange }: any) {
  const advancedFormContext = useAdvancedFormContext()
  const effectiveReadOnly = readOnly || advancedFormContext?.readOnly

  return <>
    { effectiveReadOnly && <InputStyled value={formatter(value || 0)} readOnly addonAfter={addonAfter} /> }
    { !effectiveReadOnly && <InputNumberStyled formatter={formatter} parser={parser} value={value || 0} onChange={onChange} disabled={disabled} min={min} max={max} addonAfter={addonAfter} /> }
  </>
}

export default FormItemNumber;